<template>
     <div class="mobile-app-area" style="padding-bottom: 50px;">
        <div class="container">
            <div class="row align-items-center right-side-flex">
                <div class="col-lg-6 col-md-12">
                    <div class="about-content"><span class="sub-title text-uppercase">CRM & AI-Driven</span>
                        <h2>CRM & AI-Driven Web Development </h2>
                        <p>Build CRM systems and web platforms that adapt to each user’s preferences. AI personalization
                            ensures visitors see relevant content, while automation streamlines lead management,
                            scoring, and customer support.</p>
                        <div class="features-text">
                            <h6>Industries</h6>
                            <p>B2B services, retail, real estate, healthcare, and more.
                                </p>
                                
                                   <h6>Key Benefits</h6>
                               <p> Enhanced engagement, automated workflows, higher lead conversion, scalable
                                design.</p>
                            
                            <h6>Technologies</h6>
                            <p>
                                PHP, Laravel, React, Vue.js, MySQL, MongoDB, Dialogflow, Azure Cognitive Services.
                            </p>
                            <a href="/contact" class="nav-link" style="padding:0;"><button class="default-btn">Contact Us</button></a>
                        </div>

                        <!-- <div class="btn-box"><a href="/jexa/contact" class="default-btn">Start Free Trial</a><a
                            href="/jexa/features-one" class="link-btn">See All Features</a></div> -->
                    </div>
                </div>
                <div class="col-lg-6 col-md-12"> 
                    <div class="about-img">
                        <img src="../../assets/images/AI-Driven-Web.png" data-aos="fade-up" alt="launch app"
                            class="aos-init aos-animate">
                    </div>
                </div>
 
 




            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "CrmWeb",
};  
</script>